import * as React from 'react';
import * as ReactDOM from 'react-dom';
import withStyles from 'react-jss';
import { AppMetadata, IncomingActions } from './constants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './styles';
import { flushMessageQueue, setAppLoaded } from './iframeMessageUtils';
import { setIframeLoaded } from '../../../actions/persistentIframeActions';
import { useHistory, useLocation } from 'react-router-dom';
import { ANALYTICS_BASE_PATH } from 'src/globals';

function PersistentIframeInjector(props: any) {
  const { classes, iframeInfo = {}, appName, setIframeLoaded, topRenderDistance } = props;
  const { dimensions = {}, isRendered } = iframeInfo;
  const metadata = AppMetadata[appName];
  const location = useLocation();
  const history = useHistory();

  const replaceIncomingRouteChange = (incomingRoute) => {
    const currentRoute = location.pathname.replace(ANALYTICS_BASE_PATH, '');
    if (incomingRoute !== currentRoute) {
      history.push(`/analytics${incomingRoute}`)
    }
  }

  const onApplicationLoad = (event) => {
    if (event.origin !== metadata.origin) {
      return;
    }
    let action: any = {};
    try {
      action = JSON.parse(event.data);
    } catch (e) {
      return;
    }
    if (action.applicationId === appName) {
      if (action.type === IncomingActions.Routing) {
        replaceIncomingRouteChange(action.pathname);
      }
      if (action.type === IncomingActions.Loaded) {
        setIframeLoaded(appName, true);
        setAppLoaded(appName);
        flushMessageQueue(appName);
      }
    }
  };

  React.useEffect(() => {
    window.addEventListener('message', onApplicationLoad);
  }, []);

  return ReactDOM.createPortal(
        <div className={ classes.appModal } style={{
          display: iframeInfo.visibility ? 'block' : 'none',
          top: topRenderDistance || dimensions.top,
          left: dimensions.left,
          width: `${dimensions.width || 0}px`,
          height: `${dimensions.height || 0}px`,
        }}>
          {isRendered && <iframe
            id={metadata.iframeId}
            className={ classes.customModalIframe }
            src={metadata.url}
            height="100%"
            width="100%"
            title={metadata.iframeId}
            allow="fullscreen"
          />}
        </div>,
        document.body,
    );
}

const mapStateToProps = (state, ownProps) => {
  const { persistentIframe } = state;
  const { appName } = ownProps;
  return {
    iframeInfo: persistentIframe[appName],
  };

};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    setIframeLoaded,
  }, dispatch);
};

export default connect(mapStateToProps,
  mapDispatchToProps)(withStyles(styles, { injectTheme: true })(PersistentIframeInjector));
